import { reviews } from '@/mocks/data';

export default function Reviews() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-12 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
            用户评价
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 mb-4">
            听听用户怎么说
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto text-sm md:text-base">
            来自各行各业的真实用户反馈，91牛正在帮助越来越多的人提升效率
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.slice(0, 6).map((review) => (
            <div
              key={review.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: review.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm" />
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1 mb-5">
                &ldquo;{review.content}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/70">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-10 h-10 rounded-full object-cover"
                  width={40}
                  height={40}
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-900">
                    {review.name}
                  </div>
                  <div className="text-xs text-foreground-500">{review.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}